<template>
  <el-row>
    <el-col :span="24">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/fruitt' }">精选成果库</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="wrap">
        <div class="top">
          <div class="top_img">
            <img :src="pageData.PictureUrl" alt />
          </div>
          <div class="top_text">
            <div class="title">{{ pageData.Title }}</div>
            <div class="address">
              <img src="../../../assets/library/chengguo/公司名称.png" alt />
              所属单位或公司名称：{{ pageData.CompanyOrPersonName }}
            </div>
            <div class="info_box">
              <el-row>
                <el-col :span="10">
                  <p>技术领域：{{ pageData.TechFiel }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.ProperyStatus1">
                    成果形式：{{ pageData.ProperyStatus1 }}
                  </p>
                  <p v-else>成果形式：无</p>-->
                  <p>成果形式：{{ pageData.ProperyStatus1 }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.OwnershipOfresults1">
                    成果权属：{{ pageData.OwnershipOfresults1 }}
                  </p>
                  <p v-else>成果权属：无</p>-->
                  <p>成果权属：{{ pageData.OwnershipOfresults1 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <p v-if="pageData.InvestInFunds">所需资金：{{ pageData.InvestInFunds }}万元</p>
                  <p v-else>所需资金：面议</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.Place">所属地区：{{ pageData.Place }}</p>
                  <p v-else>所属地区：无</p>-->
                  <p>所属地区：{{ pageData.Place }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.TermValidit1">
                    有效期：{{ pageData.TermValidit1 }}
                  </p>
                  <p v-else>有效期：无</p>-->
                  <p>有效期：{{ pageData.TermValidit1 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <!-- <p v-if="pageData.ModeOfCooperation1">
                    合作方式：{{ pageData.ModeOfCooperation1 }}
                  </p>
                  <p v-else>合作方式：无</p>-->
                  <p>合作方式：{{ pageData.ModeOfCooperation1 }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.Unitproperties1">
                    单位性质：{{ pageData.Unitproperties1 }}
                  </p>
                  <p v-else>单位性质：无</p>-->
                  <p>单位性质：{{ pageData.Unitproperties1 }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.Projectphase1">
                    项目阶段：{{ pageData.Projectphase1 }}
                  </p>
                  <p v-else>项目阶段：无</p>-->
                  <p>项目阶段：{{ pageData.Projectphase1 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <!-- <p v-if="pageData.UpdateTime">
                    更新时间：{{ pageData.UpdateTime }}
                  </p>
                  <p v-else>更新时间：无</p>-->
                  <!-- <p>更新时间：{{ pageData.UpdateTime }}</p> -->
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.Address">
                    信息来源：{{ pageData.Address }}
                  </p>
                  <p v-else>信息来源：无</p>-->
                  <!-- <p>信息来源：{{ pageData.Address }}</p> -->
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="top_chart">
            <div class="btn_box">
              <el-button
                class="collection"
                @click="collect"
                v-if="pageData.ClassName == 'n' || pageData.ClassName == ''"
              >
                <img src="../../../assets/library/chengguo/路径 916.png" alt />
                <span>收藏</span>
              </el-button>
              <el-button id="btn2" class="collection" @click="collect" v-else>
                <img src="../../../assets/Home/路径 916.png" alt />
                <span>已收藏</span>
              </el-button>
              <el-button class="docking" @click="wantDocking">
                <img src="../../../assets/library/chengguo/分组 39.png" alt />
                我要对接
              </el-button>
            </div>
            <div class="star">
              形式审查结果：
              <div v-for="i of pageData.Score" :key="i">
                <img src="../../../assets/library/chengguo/星星.png" alt />
              </div>
              <div v-for="i of 5 - pageData.Score" :key="i">
                <img src="../../../assets/library/chengguo/星星(1).png" alt />
              </div>
            </div>
            <!-- <div
              ref="myDiv"
              style="width: 13.125rem; height: 8.375rem; margin-top: 2.0625rem"
            ></div>-->
            <!-- <div ref="myDiv" class="myChartDiv"></div> -->
            <div class="myChartDiv">更新时间：{{ pageData.UpdateTime }} </div>
              <div class="myChartDiv">信息来源：{{ pageData.Address }} </div>
          </div>
        </div>
        <div class="center">
          <el-tabs v-model="activeName">
            <el-tab-pane label="成果详情" name="1">
              <div class="rich_Text" v-html="pageData.DetailsOfTheResults"></div>
            </el-tab-pane>
            <el-tab-pane label="第三方评定结果" name="2">
              <div style="height: 20rem;">
              <div v-if="aboutsf.length > 0" style="background-color: #F6F6F6 ;height: 3rem;">
                 <div class="sf" style="padding-top: 0.5rem;">
                 {{ aboutsf }}
                 </div>
             <div class="sfxz">   <a :href="aboutsfxz" download="aboutsfxz" target="_blank" >下载</a></div>
              </div>
              <Empty v-else /> 
              </div>
              <!-- <div class="pinggu">
                <h3>科技成果标准化评价报告</h3>
                <br />
                <br /> -->
                <!-- <div class="report">
                  <div class="bg"></div>
                  <table border="1" style="width: 50%; margin: 0 auto">
                    <colgroup>
                      <col width="150" />
                      <col />
                    </colgroup>

                    <tbody>
                      <tr>
                        <td>成 果 名 称：</td>
                        <td>{{ pageData.Title }}</td>
                      </tr>
                      <tr>
                        <td>成果完成单位</td>
                        <td>{{ pageData.CompanyOrPersonName }}</td>
                      </tr>
                      <tr>
                        <td>成果评价机构</td>
                        <td>河南省生产力促进中心</td>
                      </tr>
                      <tr>
                        <td>评 价 目 的</td>
                        <td>成果交易</td>
                      </tr>

                      <tr>
                        <td>评 价 时 间</td>
                        <td>2021年9月3日</td>
                      </tr>
                      <tr>
                        <td>编 制 时 间</td>
                        <td>二〇二一年制</td>
                      </tr>
                    </tbody>
                  </table>

                  <br />
                  <br />
                  <div class="catalogue" style>
                    <div style>目 录</div>
                    <div>综合评价结论.................................................................................................1</div>
                    <div>第一部分：科技成果概述...............................................................................2</div>
                    <div>第二部分：技术成熟度评价...........................................................................3</div>
                    <div>第三部分：技术创新度评价...........................................................................4</div>
                    <div>第四部分：技术先进度评价...........................................................................5</div>
                    <div>第五部分：效益分析.......................................................................................7</div>
                    <div>第六部分：团队评价.......................................................................................8</div>
                    <div>第七部分：专家咨询意见...............................................................................9</div>
                    <div>第八部分：附件.............................................................................................10</div>
                  </div>
                </div> -->
<!-- 
                <el-button
                  @click="gologin"
                  style="
                    margin-top: 1rem;
                    background-color: #009688;
                    color: #fff;
                  "
                >申请查看完整评估报告</el-button> -->
                <!-- <el-dialog title="提示" :visible.sync="isToDownload" width="30%"> -->
                  <!-- :before-close="handleClose" -->
                  <!-- <div
                    style="
                      margin: 0 auto;
                      width: 50%;
                      display: flex;
                      justify-content: space-between;
                    "
                    v-show="isToDownload"
                  >
                    <el-button size="mini">
                      <a href="https://www.hnkgdh.com/doctemplate/科技成果标准化评价评估报告查看申请表.docx">下载</a>
                    </el-button> -->

                    <!-- <el-button id="upload"> 上传 </el-button>
                  <br />
                  <span style="color: red; display: block; margin-top: 1.25rem">
                    (下载评估报告申请表,加盖公章后扫描上传)
                    </span>-->
                    <!-- :on-preview="handlePreview"
                      :on-remove="handleRemove"
                    :before-remove="beforeRemove"-->
                    <!-- :file-list="fileList" -->
                    <!-- :on-exceed="handleExceed" -->
                    <!-- action="http://124.70.78.125:8081/SysManage/SysManageAjaxHandler.ashx?action=UpLoadFile&filePath=AchievementUpload" -->
                    <!-- <el-upload
                      class="upload-demo"
                      :action="`SysManage/SysManageAjaxHandler.ashx?action=UpLoadFile&filePath=AchievementUpload`"
                      multiple
                      :http-request="handleRequest"
                      :on-success="uploadDone"
                      :limit="1"
                      :show-file-list="false"
                    >
                      <el-button size="small" type="primary">上传</el-button>
                      <div slot="tip" class="el-upload__tip" style="color: red">
                        
                      </div>
                    </el-upload> -->
                  <!-- </div> -->
                  <!-- <div class="tips">(下载评估报告申请表,加盖公章后扫描上传)</div> -->
                <!-- </el-dialog> -->
              <!-- </div> -->
            </el-tab-pane>
            <el-tab-pane label="对接动态" name="3">
              <div class="wk">
                <div class="dh">   
                  <div class="tit">
                    <img src="../../../assets/images/jt.png" alt />
                    <span>对接留言</span>
                  </div>
                  <div class="DockingList" v-if="msgList.length > 0">
                <div class="msgContent" v-for="(item, index) in msgList" :key="item.ID">
                  <div class="lis">
                    <div class="LeftInfo">
                      <img src="../../../assets/Home/组 4218.png" alt />
                      <div class="Left-R">
                        <p class="pname">{{ formatName(item.RealName) }}</p>
                        <p class="p-border">{{ item.Content }}</p>
                      </div>
                    </div>
                    <div class="RightTime">{{ item.createtime }}</div>
                  </div>
                  <!-- 点赞评论，回复 -->
                  <ul class="commentList">
                    <li v-for="(i, n) in coo[index]" :key="n">
                      <p>
                        <span class="commentName">{{ i.RealName }} ：</span>
                        <span class="commentText">{{ i.Content }}</span>
                      </p>
                      <p class="commentTime">{{ i.createtime.substring(0, 10) }}</p>
                    </li>
                  </ul>
                  <div class="islike">
                    <p class="comment" @click="comment(item.ID)">
                      <img src="../../../assets/images/组 24783@2x.png" alt />
                      <span>回复</span>
                    </p>
                    <!-- 点赞状态 -->
                    <!-- <p v-if="item.Is == 'Y'" @click="liked(item, index)" class="goodjob">
                      <img src="../../../assets/images/组 247866@2x.png" alt />
                      <span>{{ item.r }}</span>
                    </p> -->
                    <!-- 未点赞状态 -->
                    <!-- <p v-else class="goodjob" @click="liked(item, index)">
                      <img src="../../../assets/images/组 24786@2x.png" alt />
                      <span>{{ item.r }}</span>
                    </p> -->
                  </div>
                  <el-divider></el-divider>
                </div>
              </div>
              <Empty v-else /> 
            </div>
                <div class="zhjl">
                  <div class="tit">
                    <img src="../../../assets/images/jt.png" alt />
                    <span>转化记录</span>
                  </div>
                  <div class="jl" v-if="itemList1.length > 0">
                    <div class="xx" v-for="(item,index) in itemList1" :key="index">
                      <div class="nr">
                        <div class="time">{{item.DockingTime}}</div>
                        <div class="wz">{{item.DockingResults}}</div>
                        <div class="pic" v-for="(item,index) in item.fileList" :key="index" >
                          <img :src="item.FileUrl" alt /> 
                        </div>
                        </div>
                    </div>
                    </div>
               
                </div>
                </div>
           
            </el-tab-pane>
            <el-tab-pane label="参考资料" name="4"  >
        
       <div v-if= "ckList.length > 0"  >
              <div class="ck" v-for="(item, index) in ckList" :key="index" >
          <ul >
             <li  :class="getRowClass(index)">
              <a :href="item.ExternalLinks" target="_blank">
                <div style="display: flex;">
                <div class="xh"> {{ index + 1 }} </div>
              <div class="x">  {{item.Title}}<img src="../../../assets/images/组 24967@2x.png" alt /> </div>
              <div class="sj">{{item.websiteName}}【{{item.createTime.substring(0, 10)}}】</div>
                </div>
              </a>
                  </li>
          </ul>
                </div>
        </div>
<Empty v-else /> 
             
              </el-tab-pane>
          </el-tabs>
        </div>
        <div class="botm">
          <div class="need">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124_11.png" alt />
              <span>团队介绍</span>
            </p>
            <el-divider></el-divider>
            <div class="need_box" v-if="aboutteamCard.length > 0">
            <!-- <div class="wb" v-for="(v, i) in aboutteamCard" :key="i">
              <div class="text">{{ v.CompanyContent}}</div>
            </div> -->
            <div style="text-align: left;">{{ aboutteamCard }}</div>
            <div class="top_info_box_left" v-if="aboutvideoCard.length > 0" >
              <video controls :src="aboutvideoCard"></video>
            </div>
         <div v-else></div>
          </div>
       <Empty v-else /> 
            </div>
            <div class="need">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124_11.png" alt />
              <span>成果立项</span>
            </p>
            <el-divider></el-divider>
            <div class="need_box" v-if="length > 0">
            <div class="LX" style="border: 1px solid red;">
             
            </div>
          </div>
   <Empty v-else /> 
            </div>
            <div class="need" >
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124_11.png" alt />
              <span>佐证类附件</span>
            </p>
            <el-divider></el-divider>
            <div class="need_box" v-if="itemList.length > 0">
            <div class="fj" >
              <div class="text"  v-for="(item, i) in itemList.slice(0, 4)" :key="i">
                <p>{{item.Name}}</p>
                <div class="btn1">预览</div>
                <div class="btn3">下载</div>
              </div>
            </div>
          </div>
            <Empty v-else />
          </div>
      
          <div class="need">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124_11.png" alt />
              <span>相关需求</span>
            </p>
            <el-divider></el-divider>
            <div class="need_box" v-if="needArr.length > 0">
              <div
                class="need_card_wrap"
                v-for="(item, index) in needArr.slice(0, 6)"
                :key="index"
                @click="goNeedDetail(item)"
              >
                <div class="need_card">
                  <div class="nc_img">
                    <img :src="item.imgUrl" alt />
                  </div>
                  <div class="nc_text">
                    <div class="title">{{ item.title }}</div>
                    <div class="money">
                      预算资金：
                      <span v-if="item.money == !0">{{ item.money }}(万元)</span>
                      <span v-else>面议</span>
                    </div>
                    <div class="techarea">
                      技术领域：
                      <span>{{ item.technicalField }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Empty v-else />
          </div>
          <div class="expert">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124.png" alt />
              <span>相关专家</span>
            </p>
            <el-divider></el-divider>
            <div class="expert_box" v-if="aboutPersonCard.length > 0">
              <div class="expert_card" v-for="(v, i) in aboutPersonCard.slice(0, 3)" :key="i">
                <div class="clc-lia" @click="goTalent(v)">
                  <div class="clc-lia-name">
                    <img v-if="v.Sex == 0" src="../../../assets/library/chengguo/蒙版组 125.png" alt />
                    <img v-else src="../../../assets/library/chengguo/蒙版组 125@2x.png" alt />
                    <div>
                      <b class="FullName">{{ v.FullName }}</b>
                    </div>
                    <div class="TechnicalPosition">{{ v.TechnicalPosition }}</div>
                  </div>
                </div>
                <div class="center_box_text">
                  <div class="text_top" @click="goTalent(v)">{{ v.University }}</div>
                  <div class="text_line" @click="goTalent(v)">
                    <span>{{ v.Direction[0] }}</span>
                    <p v-if="Direction==[0]">|</p>
                    <span>{{ v.Direction[1] }}</span>
                  </div>
                  <el-button v-if="v.iscollection == 0" @click="follow(v)">+关注</el-button>
                  <el-button v-else @click="follow(v)">已关注</el-button>
                </div>
              </div>
            </div>
            <Empty v-else />
          </div>
          <div class="mechanism">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124(1).png" alt />
              <span>相关机构</span>
            </p>
            <el-divider></el-divider>
            <div class="mechanism_box">
              <div
                class="mechanism_card_wrap"
                v-for="(v, i) in OrganArr"
                :key="i"
                @click="goOrgan(v)"
              >
                <div class="mechanism_card">
                  <div class="nc_img">
                    <img :src="v.Url" alt />
                  </div>
                  <div class="nc_text">
                    <div class="title">{{ v.UnitName }}</div>
                    <div class="money">
                      单位性质：
                      <span>{{ v.UnitType }}</span>
                    </div>
                    <div class="techarea">
                      技术领域：
                      <span>{{ v.TechnicalField }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Docking
        v-if="dockShow"
        :DialogVisible.sync="dockShow"
        :id="pageData.ID.toString()"
        :type="'0'"
        :ParentId="ParentId"
      />
    </el-col>
  </el-row>
</template>

<script>
import { getAction, postAction } from '@/api/api'
import { Adaptation1} from '@/api/Adaptation'
import qs from 'qs'
import {
  library,
  cloudSelect,
  organPool,
  TypeList,
  colect,
  Docking1,
  InnovativeTalentsHandle,
  CollegesHandler
} from '@/api/url'
import Docking from '@/components/Docking.vue'
import Empty from '../../../components/empty.vue'


export default {
  name: '',
  data() {
    return {
      Direction:"",
      length:"",
      msgList: [],
      ParentId: 0,
      shatwon: [],
      coo: [],
      LYlist:[],
      activeName: '1',
      aboutPersonCard: [], // 相关专家
      aboutteamCard:[],
      aboutvideoCard:[],
      aboutsf:[],
      aboutsfxz:[],
      tditemList:[],
      itemList:[],
      itemList1:[],
      pageData: {},
      ckList:[],
      isToDownload: false,
      needArr: [], // 需求数组
      OrganArr: [], // 专家数组
      dockShow: false,
      dockArr: [], // 对接动态
      id:'',
      ck:{
        action:"GetMaterialsList",
        PersonName:'',
        
        CollegesUniversitiesName:"",
      }
    }
  },
  props: {},
  components: { Docking, Empty },
  created()
  {
 this.id=this.$route.query.id

  },
  mounted() {
    
    
    Adaptation1(this,this.id, this.id,'/fruittDetail','AchievementDetail?id=')
    this.getPageData()
    // this.getAboutNeed()
    this.getMessage()
  // this.ckList()
    window.onresize = () => {
      //调用methods中的事件
      this.myChart.resize()
    }
    this.$bus.$on('LoginSuccess', (e) => {
      //// console.log(e);
      if (e) {
        this.getPageData()
      }
    })
  },
  methods: {

    getRowClass(index) {
      return index % 2 === 0 ? 'even-row' : 'odd-row';
    },
    // handleRequest(param) {
    //   let fileObj = param.file
    //   // FormData 对象
    //   let form = new FormData()
    //   // 文件对象
    //   form.append('file', fileObj)
    //   form.append('resourceId', this.resourceId)
    //   // form.append("id", param.data.featid || param.data.XM_GUID);
    //   let self = this
    //   postAction(
    //     'SysManage/SysManageAjaxHandler.ashx?action=UpLoadFile&filePath=AchievementUpload',
    //     form
    //   ).then((res) => {
    //     //// console.log(res);
    //     if (res.code == '0') {
    //       this.uploadDone(res.url)
    //     } else {
    //       self.$message.error(res.msg)
    //     }
    //   })
    // },
    // 上传完成后回调
    uploadDone(a) {
      let data = {
        action: 'UpLoad_Achievement',
        filePath: a,
        id: this.$route.query.id,
      }
      postAction(TypeList, qs.stringify(data)).then((res) => {
        //// console.log('文件上传的回调',res);
        if (res == '3') {
          this.$message.success('文件上传成功！')
          this.isToDownload = false
        } else {
          this.$message.error('文件上传失败！')
        }
      })
    },
    // 获取对接动态
    // getDockD() {
    //   let data = {
    //     action: "Get_TechFieldList",
    //     sort: "DESC",
    //     projId: this.$route.query.id,
    //   };
    //   postAction(TypeList, qs.stringify(data)).then((res) => {
    //     //// console.log(res, "dock");
    //     this.dockArr = res;
    //   });
    // },
    //获取对接列表
    getMessage() {
      let data = {
        action: 'UserLeaveList',
        UserID: localStorage.getItem('userId'),
        // UserID:1,
        projectid: this.$route.query.id,
        // projectid: 74497,
        type: '0',
        pageIndex: '1',
        pageSize: '10',
        // ParentId:'0',
        ParentId: 0,
      }
      getAction(Docking1, data).then((res) => {
        //// console.log(res);
        this.msgList = res.list
        if (res.list.length == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        res.list.forEach((item, index) => {
          if (item.r == null) {
            item.r = 0
          }
          let b = {
            action: 'UserLeaveList',
            pageIndex: 1,
            pageSize: '',
            projectid: this.$route.query.id,
            // projectid: 74497,
            type: '0',
          }
          b.ParentId = item.ID

          ////// console.log(b);
          getAction(Docking1, b).then((res) => {
            //// console.log("评论内容", res);
            this.shatwon = res.list

            if (this.coo.length == index) {
              this.coo.push(this.shatwon)
            }
          })
        })
      })
    },

    // 点赞
    liked(a, index) {
      let RealName = localStorage.getItem('RealName')
      //// console.log("RealName", RealName);

      if (RealName == '' || RealName == null) {
        let vm = this
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        //// console.log(a);
        // this.islikeflag = !this.islikeflag;
        // //// console.log(this.islikeflag)
        let data = {
          action: 'Support',
          userid: localStorage.getItem('userId'),
          // userid:1,
          projectid: a.ID,
        }
        postAction(Docking1, this.$qs.stringify(data)).then((res) => {
          //// console.log(res);
          let data = {
            action: 'UserLeaveList',
            UserID: localStorage.getItem('userId'),
            // UserID:1,
            projectid: this.$route.query.id,
            // projectid: 74497,
            type: '0',
            pageIndex: '1',
            pageSize: '10',
            // ParentId:'0',
            ParentId: 0,
          }
          getAction(Docking1, data).then((res) => {
            //// console.log(res);
            //// console.log(index);
            if (this.msgList[index].Is == 'Y') {
              this.msgList[index].r -= 1
            } else {
              this.msgList[index].r += 1
            }

            this.msgList[index].Is = res.list[index].Is
          })
        })
      }
    },
    //评论
    comment(a) {
      //// console.log(a); //列表的ID
      this.ParentId = Number(a)

      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.dockShow = true
        // //// console.log("需求详情我要对接的ProjectID", this.ProjectID);
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.dDialogVisible)
      }
    },
    // 我要对接
    wantDocking() {
      let RealName = localStorage.getItem('RealName')
      if (RealName == '') {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.dockShow = true
        //// console.log(this.dockShow);
      }
    },
    // 收藏项目
    collect() {
      let RealName = localStorage.getItem('RealName')
      if (!RealName == '') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID') || 0,
          ProjectID: this.$route.query.id,
          Type: 1,
        }
        postAction(colect, qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success(res.info)
            this.getPageData()
          } else {
            this.$message.success(res.info)
            this.getPageData()
          }
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    goNeedDetail(a) {
      //跳转需求详情
      //// console.log(a);
      this.$router.push({
        path: '/demandDetail',
        query: {
          id: a.id,
        },
      })
    },
    // 关注专家
    follow(a) {
      //// console.log(a);
      if (!localStorage.getItem('RealID') == '0') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID'),
          ProjectID: a.id,
          Type: 3,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success('关注成功！')
            this.getAboutPerson()
          } else {
            this.$message.success('取消关注')
            this.getAboutPerson()
          }
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    // //登陆成功
    // LoginSuccess() {
    //   let data = {
    //     action: "Get_UserInfo",
    //   };
    //   postAction(library, this.$qs.stringify(data)).then((res) => {
    //     this.RealName = res.RealName;
    //     localStorage.setItem("RealName", res.RealName);
    //     localStorage.setItem("RealID", res.ID);
    //   });
    // },
    // 获取信息
    getPageData() {
      
      let data = {
        action: 'Get_AchievementInfo',
        id: this.$route.query.id,
      }

      postAction(library, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          if (res.UpdateTime) {
            res.UpdateTime = this.getdata(res.UpdateTime)
          }
          //// console.log(res.Score);
          this.pageData = res
          console.log(this.pageData.Place.substr(-1))
          if (this.pageData.Place.substr(-1) === '-') {
            this.pageData.Place = this.pageData.Place.substring(0,this.pageData.Place.length-1)
          }
          console.log('369',this.pageData.Place)
          this.getAboutPerson()
          this.getAboutteam()
          this.getAboutteam1()
          this.getAboutOrganPool()
          this.getAttachment()
          // this.$nextTick(() => {
          //   this.echartdata()
          // })
          
        }
        
      },
  
     
     
    )
    },
    // 格式化时间
    getdata(val) {
      var timestamp = val
      var date = new Date(
        parseInt(timestamp.replace('/Date(', '').replace(')/', ''), 10)
      )
      //// console.log(date);
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m
    },
    // 登录
    gologin() {
      // if (this.UserID > 0) {
      //   this.isToDownload = true;
      // } else {
      //   window.location.href = "./login.html";
      // }
      let RealName = localStorage.getItem('RealName')
      if (RealName == '') {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.isToDownload = true
      }
    },
    // 获取相关需求
    // getAboutNeed() {
    //   let data = {
    //     action: 'Get_MatchingData',
    //     id: this.$route.query.id,
    //     type: 1,
    //   }
    //   getAction(TypeList, data).then((res) => {
    //     //// console.log(res);
    //     this.getNeed(res)
    //   })
    // },
    getNeed(a) {
      let data = {
        action: 'Replay_MajorDemandInfo',
        formMap: JSON.stringify(a),
      }
      postAction(TypeList, qs.stringify(data)).then((res) => {
        console.log("返回数据" + res);
        this.needArr = res
      })
    },
    
    // 获取相关专家
    getAboutPerson() {
      //// console.log(1111111111111111111111111111111111111111111111111);
      let data = {
        action: 'GetCorrelationSpecialistList',
        id: this.$route.query.id,
        type: 0,
        userid: localStorage.getItem('RealID') || 0,
      }
      getAction(cloudSelect, data).then((res) => {
        console.log(res);
        res.list.map((item) => {
          item.Direction = item.Direction.split('|')
        })
        this.aboutPersonCard = res.list
      })
    },
    getLYlist(){ 
          let data = {
        action: 'GetHotLeaveMsg',
        projectId:'211',
        type:'0',
        leveaType: '1',
      }  
      // debugger
      getAction(Docking1, data).then((res) => {
        this.aboutteamCard = res.data.TeamIntro;
        this.aboutvideoCard = res.data.TeamIntroVideo
       
      })
    },
    //转化记录
    getAboutteam1() {

      let data = {
        action: 'Get_AchievementResumeList_v1',
        id: this.$route.query.id,
      }  
      // debugger
      getAction(CollegesHandler, data).then((res) => {
        this.itemList1 = res.data;
        console.log(123);
      })
    },
       // 获取团队简介
       getAboutteam() {
//  console.log(2233);
// debugger
      let data = {
        action: 'Get_CollegesAchievementsInfo_v1',
        id: this.$route.query.id,
      }  
      // debugger
      getAction(CollegesHandler, data).then((res) => {
        this.aboutteamCard = res.data.TeamIntro;
        this.aboutvideoCard = res.data.TeamIntroVideo
        this.aboutsf = res.data.ZxpgName
        this.aboutsfxz = res.data.ZxpgUrl
        this.ck.PersonName = res.data.Projectleader
        this.ck. CollegesUniversitiesName = res.data.CollegesUniversitiesName
        getAction(InnovativeTalentsHandle, this.ck).then((res) => {
          this.ckList = res.data
        })
      })
    },
    // 获取相关机构
    getAboutOrganPool() {
      let data = {
        action: 'Random_List',
        row: 6,
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res);
        this.OrganArr = res
      })
    },
    goTalent(a) {
      this.$router.push({
        path: '/talentPoolinfo',
        query: {
          list: a.id,
        },
      })
    },
    goOrgan(a) {
      this.$router.push({
        path: '/OrganizationDetail',
        query: {
          id: a.ID,
          type: a.Type,
        },
      })
    },
//团队介绍

    formatName(name) {
      let newStr
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*'
      } else if (name.length > 2) {
        if (
          name.indexOf('学院') != -1 ||
          name.indexOf('大学') != -1 ||
          name.indexOf('研究院') != -1 ||
          name.indexOf('中心') != -1 ||
          name.indexOf('联盟') != -1
        ) {
          newStr = name
        } else {
          let char = ''
          for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*'
          }
          newStr = name.substr(0, 1) + char + name.substr(-1, 1)
        }
      } else {
        newStr = name
      }

      return newStr
    },
    getAttachment() {
      getAction(CollegesHandler, {action:'GetFileEvidence_v1',id:this.$route.query.id,type:'1'}).then((res) => {
        this.itemList = res;
       
      });
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb {
  width: 86.25rem;
  margin: 0 auto;
  padding: 1.25rem;
}
.wrap {
  width: 87.5rem;
  box-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.06);
  opacity: 1;
  border-radius: 0rem;
  margin: 0 auto;
  padding: 2.1875rem 1.875rem;
}
.top {
  display: flex;
  justify-content: space-between;
  .top_img {
    width: 26.25rem;
    height: 14.125rem;
    overflow: hidden;
    img {
      width: 100%;
      // height: 100%;
      vertical-align: bottom;
    }
  }
  .top_text {
    width: 38.8125rem;
    margin-left: 2.5rem;
    text-align: left;
    .title {
      font-size: 1.625rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
      margin-bottom: 0.875rem;
    }
    .address {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;
      margin-bottom: 1rem;
    }
    .info_box {
      p {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        margin-top: 0.875rem;
      }
    }
  }
  .top_chart {
    .btn_box {
      display: flex;
      justify-content: flex-end;
      .collection {
        padding: 0 !important;
        text-align: center;
        width: 8.9rem;
        height: 3rem;
        background: #ff9e57;
        opacity: 1;
        border-radius: 0.3125rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        img {
          width: 1rem;
          height: 0.875rem;
          vertical-align: bottom;
        }
      }
      .docking {
        padding: 0 !important;
        text-align: center;
        width: 8.9rem;
        height: 3rem;
        background: #2769dc;
        opacity: 1;
        border-radius: 0.3125rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        img {
          width: 1rem;
          height: 0.875rem;
          vertical-align: bottom;
        }
      }
    }
    .star {
      display: flex;
      margin-top: 0.9375rem;
      div {
        flex: 1;
        img {
          width: 1.25rem;
          height: 1.25rem;
          vertical-align: bottom;
          margin: 0 0.0625rem;
        }
      }
    }
  }
}
.center {
  margin-top: 2.3125rem;
  /deep/.el-tabs__nav {
    width: 100%;
    text-align: left;
    .el-tabs__item {
      font-size: 1.75rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      margin-bottom: 0.625rem;
      color: #999999;
      opacity: 1;
    }
    .el-tabs__active-bar {
      width: 6.9375rem !important;
      height: 0.1875rem;
      background-color: #0561d2 !important;
    }
    .is-active {
      color: #0561d2 !important;
      opacity: 1;
    }
    .el-tabs__item {
    }
  }
  .rich_Text {
    text-align: left;
  }
  .pinggu {
    .report {
      position: relative;
    }
    .report > p {
      margin: 2.0625rem 0.625rem;
      font-size: 1.875rem;
      color: #333 !important;
      position: relative;
      padding-left: 12.5rem;
      text-align: left;
    }
    .bg {
      background: linear-gradient(to bottom, transparent, #fff);
      position: absolute;
      width: 100%;
      height: 101%;
      z-index: 999;
    }
    .DownTable {
    }
  }
}
/deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: 0 0;
  border-radius: 0;
}
.botm {
  margin-top: 2.3125rem;
  .need {
    margin-bottom: 2.3125rem;
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .need_box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .need_card_wrap {
      width: 26.9375rem;
      height: 22.9375rem;
      display: flex;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      margin-bottom: 1.5rem;
      .need_card {
        cursor: pointer;
        .nc_img {
          width: 26.9375rem;
          height: 14.5625rem;
          img {
            width: 100%;
            height: 100%;
            vertical-align: bottom;
          }
        }
        .nc_text {
          padding: 1.5rem;
          text-align: left;

          .title {
            width: 23.9375rem;
            font-size: 1.1875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4a4a4a;
            opacity: 1;
            margin-bottom: 1rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .money {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d0d0d0;
            opacity: 1;
            margin-bottom: 0.5rem;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #f15916;
              opacity: 1;
            }
          }
          .techarea {
            width: 100%;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c9c9c9;
            opacity: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .expert {
    margin-bottom: 2.3125rem;
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .expert_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .expert_card {
      width: 26.9375rem;
      height: 22.9375rem;
      margin-bottom: 0.625rem;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      .clc-lia {
        cursor: pointer;
      }
      .clc-lia-name {
        padding: 2.5rem 1.5rem;
        background: #f7f7f7;
        margin-top: 4.25rem;
        text-align: left;
        box-sizing: border-box;
        position: relative;
        img {
          position: absolute;
          width: 8.0625rem;
          bottom: 0;
          right: 0;
          z-index: 10;
        }
      }
      .clc-lia-name::before {
        content: '';
        display: block;
        width: 0.1875rem;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 0rem;
        transform: translateY(-50%);
        background: #0561d2;
      }
      .center_box_text {
        margin-top: 2.0625rem;
        /deep/ .el-button {
          padding: 0;
        }
        .text_top {
          margin-bottom: 0.75rem;
          font-size: 1rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .text_line {
          width: 50%;
          margin: 0 auto;
          margin-bottom: 0.625rem;
          font-size: 0.875rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 1.875rem;
          color: #999999;
          opacity: 1;
          display: flex;
          span {
            width: 45%;
            padding: 0 0.1875rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            text-align: right;
          }
        }
        /deep/ .el-button {
          width: 6.3125rem;
          height: 2.1875rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 0.25rem;
          i {
            color: #fff;
          }
          span {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            opacity: 1;
          }
        }
      }
    }
  }
  .mechanism {
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .mechanism_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .mechanism_card_wrap {
      margin-bottom: 1.5rem;
      width: 26.9375rem;
      height: 22.9375rem;
      display: flex;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      .mechanism_card {
        width: 100%;
        cursor: pointer;
        .nc_img {
          width: 26.9375rem;
          height: 14.5625rem;
          img {
            width: 100%;
            vertical-align: bottom;
          }
        }
        .nc_text {
          padding: 1.5rem;
          text-align: left;
          .title {
            width: 23.9375rem;
            font-size: 1.1875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4a4a4a;
            opacity: 1;
            margin-bottom: 1rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .money {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d0d0d0;
            opacity: 1;
            margin-bottom: 0.5rem;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
            }
          }
          .techarea {
            width: 100%;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c9c9c9;
            opacity: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              width: 100%;
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
.dockD_wrap {
  padding: 1.5rem 2.5625rem;
}
.dockD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.625rem;
  .dock_img {
    width: 3.625rem;
    height: 3.625rem;
    img {
      width: 100%;
      vertical-align: top;
    }
  }
  .dock_text {
    width: 80%;
    text-align: left;
    h3 {
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;
    }
  }
  .tiem {
    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
    }
  }
}
.FullName {
  font-size: 1.25rem;
}
.TechnicalPosition {
  color: #999;
}
.tips {
  margin-top: 1.5rem;
  color: #f15916;
}
.myChartDiv {
  margin-top: 0.7rem;
    width: 16.08rem;
    color: #666666;
    height: 1.75rem;
    text-align: left;
}
#btn2 {
  border: 0.0625rem solid #ff9e57;
  background: #ffffff;
  color: #ff9e57;
}


.commentName {
  color: #2a3457;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentTime {
  margin-top: 0.5rem;
}
.commentText {
  color: #9fa3b3;
}
.commentList {
  width: 77.625rem;
  margin: 0 auto;
  text-align: left;
  li {
    background: rgba(249, 249, 249, 0.39);
    margin-bottom: 1.25rem;
    margin-left: 4rem;
  }
}
.islike {
  display: flex;
  margin-left: 4.55rem;
  margin-bottom: 1.25rem;
  .goodjob {
    img {
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .comment {
    margin-right: 21px;
    img {
      vertical-align: middle;
      width: 14px;
      margin-right: 5px;
    }
  }
}
.text{
  width: 85.37rem;
  height: 20.5rem;
  padding: 1rem;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 2.67rem;
}
.fj{
  .text{
  width: 14.67rem;
  height: 5.5rem;
  background-color: #F5F6F8;
  padding: 2rem;
  display: block;
  float: right;
  margin-right: 2rem;
  text-align: center;
  color: #4A4A4A ;
  .btn1{
    color: #2769DC;
    background-color: #F5F6F8;
margin-top: 1rem;
margin-left: 3rem;
display: block;
float: left;
  }
  .btn3{
    color: #FF6D00 ;
    display: inline-block;
    margin-top: 1rem;
  }
}
}
.top_info_box_left {
      width: 60rem;
      height: 33.75rem;
      background: #000;
      margin-top: 5rem;
      margin-right: 12rem;
      video{
        width: 100%;
        height: 100%;
      }
    }
    .Lx{
      width: 85.37rem;
  height: 2.5rem;
 background-color: #F5F6F8 ;
    }
    .ck{
      ul{
        width: 90rem;
        
    
li{

.x{
  color: #333333 ;
 margin-left: 1rem;
   height: 1rem;
   padding-bottom: 1rem ;
   padding-top:1rem ;
      text-align: left;
      img{
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.5rem;
        margin-left: 0.5rem;
        margin-top: 0.1rem;
      }
}
.xh{
  color: #333333 ;
 margin-left: 1rem;

   padding-bottom: 1rem ;
   padding-top:1.1rem ;
      text-align: left;
}
.sj{
color: #999999 ;
   height: 1.5rem;
padding-top:1rem ;
padding-bottom: 1rem ;

      text-align: left;
}
}
      }
    }
.wk{
  width: 80rem;
  height: 38rem;
 display: flex;
 .dh{
  width: 35rem;
  height: 37rem;
.tit{
  text-align: left;
  width:7.5rem;
span{
  font-weight: bold;
  display: block;
  font-size: 20px;
  float: right;
}
img{
  width: 2rem;
  height: 2rem;
}
}
 .DockingList {
margin-top: 1rem;
  /* margin-left: 2.125rem; */
  /* margin-right: 2.375rem; */
  font-size: 1rem;
  /* 分割线 */
  /deep/.el-divider--horizontal {
    margin-top: 0;
    margin-left: 4.1875rem;
    width: 30rem;

    margin-bottom: 1.3125rem;
  }
  .lis {
    .RightTime {
      display: block;
float: right;
     margin-top: -4.5rem;
      color: #999999;
    }
  }

  .LeftInfo {
    display: flex;
    color: #666666;
    img {
      width: 2.825rem;
      height: 2.825rem;
      vertical-align: middle;
      margin-right: 1rem;
    }
    .Left-R {
      text-align: left;
      .pname {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        /* line-height: 24px; */
        color: #333333;
      }
      .p-border {
        width: 70.3125rem;
        margin-top: 0.5rem;
        padding-bottom: 1.5625rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 80%;
        /* line-height: 21px; */
        color: #666666;
      }
    }
  }
}
 }
 .zhjl{
  width: 40rem;
  height: 37rem;

padding-left: 2rem;
  text-align: left;
  .tit{
  text-align: left;
  width:7.5rem;
span{
  font-weight: bold;
  display: block;
  font-size: 20px;
  float: right;
}
img{
  width: 2rem;
  height: 2rem;
}

}
.jl{
  width: 37.5rem;

  margin-left: 2.5rem;
  margin-top: 1rem;
}
.xx{
  width: 37.5rem;
  margin-bottom: 0.5rem;
  .nr{
 width: 37.5rem;
 .time{
  font-weight: bold;
  margin-bottom: 0.5rem;
 }
 .pic{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  width: 37rem;
  display: flex;
  img{
    width: 16rem;
    height: 10rem;
    margin-right: 1rem;
  }
 }
  }
}
 }
 
}
.even-row {
  background-color:white; /* 偶数行背景色 */
}
.odd-row {
  background-color: #F6F6F6 ;
  border-bottom:1px solid  #F6F6F6; /* 奇数行背景色 */
}
a{
  color: #000;
}
.sf{

  text-align: left;
  margin-top: 1rem;
margin-left: 2rem;
font-size:20px ;
}
.sfxz{
margin-top: -1.5rem;
width:3rem;
background-color: white;
margin-left: 30rem;
padding-left: 0.3rem;
border: 1px solid black;
border-radius: 5px;
}
</style>